<template>
  <div class="h-screen overflow-y-hidden">
    <slot name="top-bar" />
    <main class="grid h-full grid-cols-1 grid-rows-[auto_1fr] gap-6 p-8 pt-8">
      <slot></slot>
    </main>
  </div>
</template>
